import tippy from "tippy.js";
import "tippy.js/dist/tippy.css"; 


const tippyHandler = function (next) {
	const tippyElements = next.querySelectorAll(".tippy");
	tippy(tippyElements, {
		content(reference) {
			const content = reference.getAttribute("data-tippy-content");
			return content;
		},
		theme: "fame",
	});
};

export default tippyHandler;
